import React from 'react';
import { useDispatch } from 'react-redux';
import VendorDetailsList from '../../components/vendorDetailsComponents/VendorDetailsList';
import { setHeaderName } from '../../redux/actions/userActions';

const VendorDetailsListPage = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Vendor'));
    return <VendorDetailsList />
}

export default VendorDetailsListPage